import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import {
  IconArrowBigDownFilled,
  IconAt,
  IconBolt,
  IconExchange,
  IconFileInvoice,
  IconRocket,
} from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";

export const RECEIVING_LIGHTNING_PAYMENTS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      When you first start Rizful, you'll find that you can't receive lighting
      payments -- the button will be disabled:
    </p>
    <DocsButton
      ariaLabel="receive lightning"
      text="Receive Lightning"
      leftSection={<IconBolt />}
      disabled={true}
    />
    <p>
      In order to receive payments, you need Inbound Capacity. The easiest way
      to get inbound capacity is to{" "}
      <a href="/docs/getting-inbound#inbound-from-rizful-lsp" target="_blank">
        Rizful Node$1 get inbound from Rizful
      </a>
      , although there are{" "}
      <a href="/docs/balances-and-capacities#inbound-capacity" target="_blank">
        other strategies
      </a>
      .
    </p>
    <p>
      Once you have inbound capacity, you can receive payments. The "Receive
      Lightning" button will be enabled:
    </p>
    <DocsButton
      ariaLabel="receive lightning"
      text="Receive Lightning"
      leftSection={<IconBolt />}
    />
    You then have two options. You can either get a lightning address or
    generate a unique, one-time lightning invoice.
  </TypographyStylesProvider>
);
